import { creatorbase } from '@round/api';
import { getTableMetaHelper } from '@round/ui-kit';

export type PurchaseOrderRowAllocation = creatorbase.PurchaseOrderLine & {
    brand: creatorbase.Brand | null;
    campaign: creatorbase.Campaign | null;
    project: creatorbase.Project | null;
};

export type PurchaseOrderRow = creatorbase.PurchaseOrder & {
    team: creatorbase.Team | null;
    createdBy: creatorbase.User | null;
    allocations: PurchaseOrderRowAllocation[];
};

export type PurchaseOrderListMeta = {
    isLoading: boolean;
    onEditPurchaseOrder: (po: PurchaseOrderRow) => void;
    onDeletePurchaseOrder: (po: PurchaseOrderRow) => void;
    onAllocatePurchaseOrder: (po: PurchaseOrderRow) => void;
    getIsTeamLoading: (po: PurchaseOrderRow) => boolean;
    getIsUserLoading: (po: PurchaseOrderRow) => boolean;
    getIsAllocationsLoading: (po: PurchaseOrderRow) => boolean;
    getIsCampaignLoading: (allocation: PurchaseOrderRowAllocation) => boolean;
    getIsBrandLoading: (allocation: PurchaseOrderRowAllocation) => boolean;
    getIsProjectLoading: (allocation: PurchaseOrderRowAllocation) => boolean;
    refetch: () => void;
};

export const getTableMeta = getTableMetaHelper<PurchaseOrderListMeta>();

export const MAX_DISPLAYED_ALLOCATIONS_COUNT = 6;
